import { render } from "./ShippingMethodCustomerGroups.vue?vue&type=template&id=f8b23222&scoped=true&ts=true"
import script from "./ShippingMethodCustomerGroups.vue?vue&type=script&lang=ts"
export * from "./ShippingMethodCustomerGroups.vue?vue&type=script&lang=ts"

import "./ShippingMethodCustomerGroups.vue?vue&type=style&index=0&id=f8b23222&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\dobby\\dobbyshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8b23222"]])

export default __exports__